import { useEffect, useState } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Alert, Spin, Typography } from 'antd'
import { supabase } from '@/lib/supabase'
import { isAuthorizedAdmin, useAuthStore } from '@/auth/session'

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallback,
})

function AuthCallback() {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    async function handle() {
      // detectSessionInUrl: true + PKCE 会让 supabase client 自动用 URL 上的
      // ?code=...&state=... 换取 session。这里轮询等待 session 落地。
      for (let i = 0; i < 40; i++) {
        const { data, error: sessionError } = await supabase.auth.getSession()
        if (cancelled) return
        if (sessionError) {
          setError(sessionError.message)
          return
        }
        if (data.session) {
          useAuthStore.getState().setSession(data.session)
          const claims = useAuthStore.getState().claims
          if (!isAuthorizedAdmin(claims)) {
            await supabase.auth.signOut()
            if (cancelled) return
            navigate({
              to: '/login',
              replace: true,
              search: { from: undefined },
            })
            return
          }
          navigate({ to: '/dashboard', replace: true })
          return
        }
        await new Promise((r) => setTimeout(r, 150))
      }
      setError('登录回调超时，请重试')
    }

    void handle()
    return () => {
      cancelled = true
    }
  }, [navigate])

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 16,
        padding: 24,
      }}
    >
      {error ? (
        <Alert
          type="error"
          showIcon
          message={error}
          style={{ width: '100%', maxWidth: 360 }}
        />
      ) : (
        <>
          <Spin size="large" />
          <Typography.Text type="secondary">正在完成登录…</Typography.Text>
        </>
      )}
    </div>
  )
}
